import type { TaskSlaDashboardData } from '@/lib/services/taskSlaService'
import ReportBarChart from '@/components/reports/ReportBarChart'

const AGING_COLORS = {
  fresh: '#38A169',
  aging: '#D69E2E',
  old: '#DD6B20',
  critical: '#E53E3E',
} as const

type Props = {
  data: TaskSlaDashboardData
  loading?: boolean
}

export default function TaskAgingCard({ data, loading }: Props) {
  const agingChartData = [
    { label: 'Fresh (≤24h)', count: data.aging.fresh, color: AGING_COLORS.fresh },
    { label: 'Aging (≤48h)', count: data.aging.aging, color: AGING_COLORS.aging },
    { label: 'Old (≤72h)', count: data.aging.old, color: AGING_COLORS.old },
    { label: 'Critical (73h+)', count: data.aging.critical, color: AGING_COLORS.critical },
  ]

  return (
    <ReportBarChart
      title="Open task aging"
      subtitle={`${data.aging.total_open.toLocaleString()} open tasks by age bucket`}
      data={agingChartData}
      loading={loading}
      height={200}
      emptyMessage="No open tasks in aging buckets."
    />
  )
}
